<!-- 添加访客接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "2KKN6112",
          "specialCarTypeName": "访客特殊车辆类型",
          "vipGroupType": 1,
          "dynamicFullLimit": 0,
          "isDynamicMode": 0,
          "openVipFullLimit": 1,
          "vipFullLimitValue": 1,
          "vipFullOpenModel": 0,
          "description": "测试特殊车辆类型",
          "isChargeGroupRelated": 1,
          "chargeGroupCodeList": [
            "0"
          ]
        },
        responseCode: {
          "data": {
            "specialCarTypeId": 1
          }, "message": "业务成功", "resultCode": 0, "status": 1
        }, infoData: {
          explain: "第三方接入系统请求智慧停车开放平台添加特殊车辆类型",
          t_url: this.commonUrls.test + "addSpecialCarType",
          p_url: this.commonUrls.prod + "addSpecialCarType",
          precondition: "无",
          fitSystem: "VEMS传统停车场，云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号'},
              {info1: 'specialCarTypeName', info2: '是', info3: 'String', info4: '特殊车辆类型名称'},
              {
                info1: 'vipGroupType',
                info2: '是',
                info3: 'Integer',
                info4: 'VIP组类型  1-访客VIP 2-黑名单VIP'
                // info4: 'VIP组类型  1-访客VIP 2-黑名单VIP，3预定vip'
              },
              {info1: 'isDynamicMode', info2: '否', info3: 'Integer', info4: '是否多位多车（0否，1是）'},
              {info1: 'dynamicFullLimit', info2: '否', info3: 'Integer', info4: '是否多位多车满位，同组在场车无法进入（0否，1是）（isDynamicMode为1时生效）'},
              {info1: 'openVipFullLimit', info2: '否', info3: 'Integer', info4: '是否开启vip满位控制,（0否,1是）'},
              {info1: 'vipFullLimitValue', info2: '否', info3: 'Integer', info4: 'vip满位阈值（openVipFullLimit为1时必填）'},
              {
                info1: 'vipFullOpenModel',
                info2: '否',
                info3: 'Integer',
                info4: 'VIP满位放行模式（0有空位自动放行，无空位手动放行按VIP计费 1有空位自动放行，无空位手动放行按临时车计费 2无空位自动放行，按临时车计费）（openVipFullLimit为1时必填）'
              },
              {info1: 'isChargeGroupRelated', info2: '否', info3: 'Integer', info4: '是否关联收费组(0否,1是，默认为否)'},
              {info1: 'chargeGroupCodeList', info2: '否', info3: 'String[]', info4: '收费组编号（chargeGroupRelated为1时必填）'},
              {info1: 'description', info2: '否', info3: 'String', info4: '简介'},
			  {info1: 'channelList', info2: '否', info3: 'JSONArray', info4: '权限通道'}
            ]
          },{
                    titleName: 'channelList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'channelSeq', info2: '是', info3: 'Long', info4: '通道id' },
						
                     { info1: 'areaId', info2: '是', info3: 'Long', info4: '区域id' }
                    ]
                }],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'specialCarTypeId', info2: '是', info3: 'Long', info4: '特殊车辆类型编号'}
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{tableHead: '状态码', tdName: 'info1'}, {tableHead: '说明', tdName: 'info2'}],
            td: [{info1: '000110', info2: '失败',}, {info1: '00110000', info2: '失败',}, {info1: '110000', info2: '失败',}]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
   /* @import "../../assets/less/conmon.less"; */
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/addSpecialCarType.vue